import { faEdit, faReceipt, faTrash } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { ColumnDescription } from "react-bootstrap-table-next";
import {
    DeletarStatusPorTipoCasoController,
    ListarStatusPorTipoCasoController,
} from "../../../Controllers/Geral/StatusEtapa/StatusEtapaController";
import useAsyncEffect from "../../../hooks/useAsyncEffect";
import type * as CSS from "csstype";
import { useState } from "react";
import LazySelect from "../../../Components/CardsPages/Forms/LazySelect";
import { ListarModulosController } from "../../../Controllers/Geral/Documentos/DocumentosController";
import ModalComponent from "../../../Components/Modais";
import Table from "../../../Components/Table";
import { IComponentModal } from "../../../Components/Modais/IModalComponent";
import useAsyncCallback from "../../../hooks/useAsyncCallback";
import { IListaStatusEtapa } from "../../../Interfaces/Repasse/StatusEtapa/StatusEtapaInterface";
import CriarStatusEtapa from "./CriarStatusEtapa";

interface Style extends CSS.Properties, CSS.PropertiesHyphen {}

interface IGestaoStatusEtapaProps {}

export default function GestaoStatusEtapa(props: IGestaoStatusEtapaProps) {
    const [modal, setModal] = useState<IComponentModal>();
    const [show, setShow] = useState(false);
    const [idModulo, setIdModulo] = useState(0);

    const {
        value: listarStatusEtapa,
        loading: listarStatusEtapaLoading,
        execute: updateList,
    } = useAsyncEffect(
        () => ListarStatusPorTipoCasoController(idModulo),
        [idModulo]
    );

    const { execute: deletarStatusEtapa } = useAsyncCallback(
        DeletarStatusPorTipoCasoController
    );

    const style: Style = {
        height: "1px",
        width: "1px",
    };

    const tableviewColumns: Array<ColumnDescription<IListaStatusEtapa>> = [
        {
            dataField: "DS_ETAPA",
            text: "",
            formatter: (c, row) => (
                <div className="d-flex flex-md-nowrap flex-wrap justify-content-between p-3">
                    <div>
                        <h6>{c ? c : row.DS_STATUS_ETAPA}</h6>
                    </div>

                    <div className="Button-Tools">
                        <button
                            className="btn btn-outline-primary font-weight-bold mr-2 "
                            onClick={() => {
                                setShow(true);
                                setModal({
                                    headerComponent: "Editar Status Etapa",
                                    IconHeader: faReceipt,
                                    Component: () => (
                                        <CriarStatusEtapa
                                            idTipoCaso={idModulo}
                                            idCategoria={
                                                row.ID_CATEGORIA_ATENDIMENTO ??
                                                0
                                            }
                                            editando={true}
                                            row={row}
                                            updateList={updateList}
                                            setShow={setShow}
                                        />
                                    ),
                                });
                            }}
                        >
                            <FontAwesomeIcon icon={faEdit} size="lg" />{" "}
                            <span className="d-none d-sm-block">Editar</span>
                        </button>
                        <button
                            className="btn btn-outline-danger font-weight-bold mr-2"
                            onClick={() =>
                                deletarStatusEtapa(
                                    row.ID_STATUS_ETAPA ?? 0
                                ).then((res) => updateList())
                            }
                        >
                            <FontAwesomeIcon icon={faTrash} size="lg" /> Excluir
                        </button>
                    </div>
                </div>
            ),
        },
        {
            dataField: "DS_ETAPA_CATEGORIA_ATENDIMENTO_TIPO_CASO",
            text: "",
            style: style,
            isDummyField: true,
            // classes: "d-none",
        },
    ];

    return (
        <div className="card card-custom p-4">
            <div className="d-flex align-items-center col-12 d-flex justify-content-between">
                <h3 className="card-title align-items-start ">
                    <span className="card-label font-weight-bolder text-dark">
                        Status por Etapa
                    </span>
                </h3>
                {idModulo ? (
                    <button
                        className="btn btn-primary"
                        onClick={() => {
                            setShow(true);
                            setModal({
                                headerComponent: "Criar Status Etapa",
                                IconHeader: faReceipt,
                                Component: () => (
                                    <CriarStatusEtapa
                                        idTipoCaso={idModulo}
                                        idCategoria={0}
                                        updateList={updateList}
                                        setShow={setShow}
                                    />
                                ),
                            });
                        }}
                    >
                        Criar Status Etapa
                    </button>
                ) : (
                    <></>
                )}
            </div>

            <LazySelect
                controller={ListarModulosController}
                getDS={(ca) => ca.DS_MODULO}
                getKeyValue={(ca) => ca.ID_MODULO}
                name="ID_MODULO"
                label="Modulo"
                onChange={(e) => setIdModulo(Number(e.target.value))}
                className="form-control placeholder-dark-75 mb-4"
            >
                <option></option>
            </LazySelect>
            <Table
                wrapperClasses="mw-100 custom-scroll"
                columns={tableviewColumns}
                data={listarStatusEtapa ?? []}
                loading={listarStatusEtapaLoading}
                keyField="ID_FORMULARIO"
                noDataIndication={() => (
                    <div className="text-black-50 text-center">
                        Nenhum Status Encontrado
                    </div>
                )}
                noHover
                noSearch
                bordered={false}
                striped={true}
                rowClasses={"rowClasses"}
                center={true}
            />

            <ModalComponent
                show={show}
                setShow={setShow}
                ModalComponent={modal}
            />
        </div>
    );
}
